import { Add, Search } from "@mui/icons-material";
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Grid,
  Paper,
  TableCell,
  TableRow,
  TextField,
} from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import {
  CustomerReviewItem,
  SearchCustomerReviewQuery,
} from "../../../interfaces/homePage";
import { makeid } from "../../../utils";
import { useGlobalContext } from "../../../context/MyGlobalContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import ContentLayout from "../../../components/Table/ContentLayout";
import mockForm from "../../../data/mockForm";
import TableHeading from "./TableHeading";
import TableItem from "./TableItem";
import customerReviewService from "../../../services/customerReviewService";
const CustomerReview = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams, setSearchparams] = useSearchParams();
  const { language } = useGlobalContext();
  const [keyReset, setKeyReset] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [keyWord, setKeyWord] = React.useState(searchParams.get("keyWord") ?? "");
  const [country, setCountry] = React.useState<string | null>(searchParams.get("country"));
  const [total, setTotal] = React.useState(0);
  const [data, setData] = React.useState<CustomerReviewItem[] | null>(null);
  const [page, setPage] = React.useState(Number(searchParams.get("page")) ? Number(searchParams.get("page")) : 1);
  const [perPage, setPerPage] = React.useState(Number(searchParams.get("pageSize")) ? Number(searchParams.get("pageSize")) : 10);  

  const fetchListData = async (payload: SearchCustomerReviewQuery) => {
    setLoading(true);
    setSearchparams({
      ...(payload.review && { review: payload.review }),
      ...(payload.fullname && { fullname: payload.fullname }),
      ...(payload.country && {
        country: String(payload.country),
      }),
      page: String(payload.pageNumber),
      pageSize: String(payload.pageSize),
     });
    const response = await customerReviewService.getList(payload);

    if (response?.status === 200) {
      setData(response.data.data);
      setTotal(response.data.total);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchListData({
      language: language ?? "en",
      pageSize: perPage,
      pageNumber: page,
      ...(country && { country: String(country) }),
      ...(keyWord.length > 0 && { review: keyWord }),
      ...(keyWord.length > 0 && { fullname: keyWord }),
    });
  }, [language, perPage, page]);
  
  return (
    <Paper sx={{ p: 2, mb: 3 }}>
      <ContentLayout
        isReverse={true}
        extraActions={
          <Grid container spacing={2}>
            <Grid item xs={12} md={2}>
                <Box sx={{boxShadow: 1}} className="rounded-10 py-20 flex-center">
                   <Button
                   className="h-45"
                variant="contained"
                endIcon={<Add />}
                onClick={() => navigate("/homepage/customer-review/add-review")}
              >
                {t("addNewButton")}
              </Button> 
                </Box>
              
            </Grid>
            <Grid item xs={12} md={2} />
            <Grid item xs={12} md={8}>
            <Box sx={{boxShadow: 1}} className="rounded-10 pt-20 pb-12 px-20 flex-center">

              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    size="small"
                    label={t("homePage_customerReview_list_filter_keyWordField")}
                    value={keyWord}
                    placeholder="Enter keywords"
                    onChange={(e) => setKeyWord(e?.target?.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
              
                <Grid item xs={12} md={4}>
                  <Autocomplete
                    sx={{
                      ".MuiOutlinedInput-root .MuiAutocomplete-input": {
                        padding: "16.5px 14px",
                      },
                    }}
                    size="small"
                    id="country"
                    getOptionLabel={(option) => option.label}
                   value={mockForm.countryOptions.find(option => option.label === country) ?? null}
                    onChange={(e, value) => {
                      if (value) {
                        setCountry(value.label);
                      } else {
                        setCountry(null);
                      }
                    }}
                    options={mockForm.countryOptions}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={t("homePage_customerReview_list_filter_countryField")}
                        defaultValue={""}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        placeholder="Select country"
                      />
                    )}
                  />
                </Grid>
                <Grid
                        item
                        xs={12}
                        md={4}
                        className="d-flex align-start gap-16"
                      >
                        <Button
                          variant={"contained"}
                          onClick={() => {
                            fetchListData({
                              language: language ?? "en",
                              pageSize: perPage,
                              pageNumber: 1,
                              ...(country && { country: String(country) }),
                              ...(keyWord.length > 0 && { review: keyWord }),
                              ...(keyWord.length > 0 && { fullname: keyWord }),
                            })
                            // setSearchparams({
                            //   ...(keyWord.length > 0 && { review: keyWord }),
                            //   ...(keyWord.length > 0 && { fullname: keyWord }),
                            //   ...(country && {
                            //     country: String(country),
                            //   }),
                            //   page: String(1),
                            //   pageSize: String(perPage),
                            //  });
                          }}
                          className="text-capitalize h-45"
                          endIcon={<Search />}
                        >
                          {t("searchButton")}
                        </Button>
                        <Button
                          variant={"contained"}
                          color="inherit"
                          onClick={() => {
                            setKeyWord("");
                            setCountry("");
                            fetchListData({
                              language: language ?? "en",
                              pageSize: perPage,
                              pageNumber: page,
                            })
                            // setSearchparams({});
                            setKeyReset(makeid(5));
                          }}
                          className="text-capitalize h-45"
                        >
                          {t("clearButton")}
                        </Button>
                      </Grid>
              </Grid>
              </Box>
            </Grid>
          </Grid>
        }
        total={total}
        tableHeading={<TableHeading />}
        tableContent={
          loading ? (
            <TableRow className="item-hover">
              <TableCell colSpan={15} align="center">
                <CircularProgress />
              </TableCell>
            </TableRow>
          ) : !data ? (
            <TableRow className="item-hover">
              <TableCell colSpan={15} align="center">
                <CircularProgress />
              </TableCell>
            </TableRow>
          ) : data.length > 0 ? (
            data.map((e: CustomerReviewItem, i: number) => (
              <TableItem
                key={i}
                data={e}
                dataKey={i}
                childrenCallback={() => fetchListData({
                  language: language ?? "en",
                  pageSize: perPage,
                  pageNumber: page,
                })}
              />
            ))
          ) : (
            <TableRow className="item-hover">
              <TableCell colSpan={15} align="center">
                {t("table_data_notFound")}
              </TableCell>
            </TableRow>
          )
        }
        page={page}
        setPage={setPage}
        perPage={perPage}
        setPerPage={setPerPage}
      />
    </Paper>
  );
};

export default CustomerReview;
